<template>
  <div class="small-width p-t-40">
    <div class="customer row">
      <div class="col-xs-4 sticky-100">
        <div class="flex-center m-b-40 h-40">
          <div class="flex-center">
            <Btn
              @click.native="routeIt"
              class="light bordered empty d-inline-block m-r-15 fix-40"
              :icon="{
              name: 'arrowLeftBig',
              size: '20',
            }" />
            <p class="user-name">{{ $t('customer') }} # {{ $route.params.id }}</p>
          </div>
        </div>
        <div class="user-card">
          <div class="card">
            <div class="image-holder showIcon">
              <Icon
                name="single"
                :size="64" />
            </div>
            <p class="title-name m-b-20">
              {{ get_customer.type == 1 ? get_customer.company_name : get_customer.name }}
            </p>
            <p class="info-list-title" v-if="get_customer.type == 1">{{ get_customer.name }}</p>
            <p class="info-list-title" v-if="get_customer.external_customer_no">External customer no: {{ get_customer.external_customer_no }}</p>
            <ul class="contact-info">
              <li>
                <Icon
                  :circle="true"
                  name="pin"
                  size="20"
                />
                <p class="info-list-title">{{ $t('address_1') }}</p>
                <p class="info-list-text">{{ get_customer.address_1 }}</p>
                <p class="info-list-text" v-if="get_customer.address_2">{{ get_customer.address_2 }}</p>
                <p class="info-list-text">{{ `${get_customer.post_code} ${get_customer.city}` }}</p>
                <p class="info-list-text">{{ get_customer.country }}</p>
                <p class="info-list-text" v-if="get_customer.state">{{ get_customer.state }}</p>
                <p class="info-list-text" v-if="get_customer.vat">{{ get_customer.vat }}</p>
              </li>
            </ul>
            <div class="clear-float">
              <Btn
                @btnClick="openEditPopup"
                class="brand d-inline-block"
                :icon="{
                name: 'pen',
                size: '18',
              }"
                :btnText="$t('Edit profile')" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-8">
        <h2 class="page-title heighted">{{ $t('contacts') }}</h2>
        <div class="table">
          <div class="table-body">
            <div v-for="(item, index) in addressesForRender" :key="`tr-${index}`">
              <TableRow
                style="cursor: pointer;"
                @click.native="openAddressFormPopup(item)"
                :type="type"
                :listItem="{...item, country_id: getCountry(item.country_id, 'name')}"
                :data="referenceData" />
            </div>
          </div>
          <Btn
            @btnClick="openAddressFormPopup"
            class="brand d-inline-block"
            :icon="{
            name: 'pen',
            size: '18',
          }"
            :btnText="$t('add_contact')" />
        </div>
      </div>
    </div>
    <Popup
      v-if="edit"
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showDeleteButton="deleteCustomer"
      :showConfirmButton="!deleteCustomer"
      @deleteAction="deleteCustomerAction"
      @cancel="closeEditPopup"
      @confirm="submitEditForm">
      <template v-slot:header>
        <h2>{{ $t('edit') }} {{ get_customer.name}}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('type')"
              v-model="formInfo.type"
              :options="typeOptions" />
          </div>
          <InputText
            v-if="formInfo.type == 1"
            class="col-xs-12 m-b-20"
            :label="$t('vat')"
            :rules="{required: false}"
            v-model="formInfo.vat"/>
          <InputText
            v-if="formInfo.type == 1"
            class="col-xs-12 m-b-20"
            :label="$t('company')"
            :rules="{required: true}"
            v-model="formInfo.company_name"/>
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('name')"
            v-model="formInfo.name"
            :rules="{required: formInfo.type == 2}" />
        </div>
        <AddressPicker
          class="m-b-input m-b-20"
          :label="$t('address_1')"
          placeholder="Search address"
          @addressSelected="changeAddress($event)"
          v-model="formAddress" />
        <div class="row">
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('external_customer_no')"
            v-model="formInfo.external_customer_no"
            :rules="{required: false}"/>
        </div>

        <!-- Additional Shipping Information Section -->
        <div class="separator medium m-b-20"></div>
        <h3 class="m-b-20">{{ $t('additional_information') }}</h3>

        <!-- INCOTERMS -->
        <div class="row">
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('Incoterms')"
              v-model="additionalShippingInfo.goods_incoterm"
              @change="checkDutyAndCarrierNo"
              :options="incotermsOptions"
            />
          </div>
          <!-- DUTY PAID BY -->
          <div
            v-if="additionalShippingInfo.goods_incoterm === 'DDP'"
            class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('duty_paid_by')"
              v-model="additionalShippingInfo.duty_paid_by"
              @change="checkCarrierNo"
              :options="dutyPaidByOptions"
            />
          </div>
        </div>

        <!-- CARRIER NUMBER -->
        <div class="row" v-if="(additionalShippingInfo.duty_paid_by === 3 || additionalShippingInfo.duty_paid_by === 2) && additionalShippingInfo.goods_incoterm === 'DDP'">
          <div class="col-xs-12 m-b-20">
            <InputText
              v-model="additionalShippingInfo.duty_payer_account_no"
              :label="$t('Carrier account no.')"
            />
          </div>
        </div>

        <!-- FREIGHT PAID BY -->
        <div class="row">
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('freight_paid_by')"
              v-model="additionalShippingInfo.freight_paid_by"
              @change="checkFreightandCustomerInfo"
              :options="freightPaidByOptions"
            />
          </div>
          <!-- FREIGHT NUMBER -->
          <div
            v-if="additionalShippingInfo.freight_paid_by === 2 || additionalShippingInfo.freight_paid_by === 3"
            class="col-xs-6 m-b-20">
            <InputText
              v-model="additionalShippingInfo.freight_payer_account_no"
              :label="$t('Freight Carrier account no.')"
            />
          </div>
          <div
            v-if="additionalShippingInfo.freight_paid_by === 4"
            class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('LBL_PAYERS')"
              v-model="additionalShippingInfo.freight_payer_id"
              :options="get_payer_select"
            />
          </div>
        </div>

        <!-- Customs Information -->
        <div class="row">
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :label="$t('LBL_REASON_FOR_EXPORT')"
              v-model="additionalShippingInfo.invoice_type"
              :options="invoiceTypeOptions"
            />
          </div>
          <div class="col-xs-6 m-b-20">
            <InputSelect
              :multiSelect="true"
              :label="$t('Additional info')"
              v-model="selectedInfoItems"
              @input="selectAdditionalInfo"
              :options="additionalInfoOptions"
            />
          </div>
        </div>

        <!-- Conditional fields based on selected additional info -->
        <div class="row" v-if="selectedInfoItems.indexOf('22') > -1">
          <div class="col-xs-12 m-b-20">
            <InputText
              :label="$t('Text')"
              v-model="additionalShippingInfo.customs_additional_info_text"
            />
          </div>
        </div>

        <div class="row" v-if="selectedInfoItems.indexOf('2') > -1">
          <div class="col-xs-12 m-b-20">
            <InputText
              :label="$t('ECCN number')"
              v-model="additionalShippingInfo.eccn"
            />
          </div>
        </div>

        <div class="row" v-if="selectedInfoItems.indexOf('3') > -1">
          <div class="col-xs-6 m-b-20">
            <InputText
              :label="$t('EEI number')"
              v-model="additionalShippingInfo.eei_number"
            />
          </div>
          <div class="col-xs-6 m-b-20">
            <InputText
              :label="$t('Tin number')"
              v-model="additionalShippingInfo.tin_number"
            />
          </div>
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('Tin type')"
              v-model="additionalShippingInfo.tin_type"
              :options="tinTypeOptions"
            />
          </div>
        </div>

        <div class="clear-float separator medium"></div>
        <div class="col-xs-12 p-b-20">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('delete') }}</p>
              <span>{{ $t('Customer will be deleted') }}</span>
            </div>
            <div>
              <Toggle color="red" id="deleteCustomer" v-model="deleteCustomer"/>
            </div>
          </div>
        </div>
      </div>
    </Popup>

    <!-- ADDRESS POPUP (unchanged) -->
    <Popup
      v-if="addressFormPopup"
      :isPopupSubmitDisabled="isPopupAddressSubmitDisabled"
      :showConfirmButton="!deleteAddress"
      :showDeleteButton="deleteAddress"
      @deleteAction="deleteAddressAction"
      @cancel="closeAddressFormPopup"
      @confirm="submitAddressForm">
      <template v-slot:header>
        <h2 v-if="!isAddressEdit">{{ $t('add_contact') }}</h2>
        <h2 v-else>{{ $t('edit_contact') }}</h2>
      </template>
      <div>
        <div class="row m-b-20">
          <InputText
            class="col-xs-12"
            :label="$t('name')"
            :rules="{required: true}"
            v-model="addressFormInfo.name" />
        </div>
        <div class="row m-b-20">
          <InputText
            class="col-xs-12 m-b-20"
            label="Email"
            v-model="addressFormInfo.email"
            :rules="{required: true}"/>
          <PhoneSelect
            class="col-xs-12 m-b-20"
            v-model="addressFormInfo.phone"
            :rules="{required: true}"/>
        </div>
        <div class="separator medium" v-if="isAddressEdit"></div>
        <div class="col-xs-12 p-b-20" v-if="isAddressEdit">
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('delete') }}</p>
              <span>{{ $t('Contact will be deleted') }}</span>
            </div>
            <div>
              <Toggle color="red" id="delete" v-model="deleteAddress" />
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import TableRow from '@/components/table/tableRow.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';

import formValidator from '@/mixins/formValidator';
import mixins from '@/mixins/mixins';
import stateList from '@/data/state.js';
import i18n from '@/i18n';

export default {
  name: 'Customer',
  components: {
    Btn,
    Popup,
    InputText,
    AddressPicker,
    PhoneSelect,
    TableRow,
    InputSelect,
    Toggle,
  },
  mixins: [mixins, formValidator],
  data() {
    return {
      // REFACTOR ADDRESS FORM
      addressFormPopup: false,
      isAddressEdit: false,
      deleteAddress: false,
      addressId: '',
      addressFormAddress: {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        state: '',
        country_id: '',
      },
      addressFormInfo: {
        name: '',
        email: '',
        vat: '',
        phone: {
          number: '',
          country: '',
        },
      },
      // Customer form
      edit: false,
      deleteCustomer: false,
      formInfo: {
        name: '',
        company_name: '',
        email: '',
        type: '',
        vat: '',
        phone: {
          number: '',
          country: '',
        },
        external_customer_no: ''
      },
      formAddress: {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        state: '',
        country_id: '',
      },
      // Additional shipping information
      additionalShippingInfo: {
        goods_incoterm: '',
        duty_paid_by: '',
        duty_payer_account_no: '',
        freight_paid_by: '',
        freight_payer_account_no: '',
        freight_payer_id: '',
        invoice_type: '',
        eori: '',
        eccn: '',
        customs_additional_info_text: '',
        eei_number: '',
        tin_number: '',
        tin_type: '',
      },
      selectedInfoItems: [],
      typeOptions: [
        {
          text: `${this.$t('Private')}`,
          value: 2,
        },
        {
          text: `${this.$t('Business')}`,
          value: 1,
        }
      ],
      incotermsOptions: [
        { text: `${this.$t('DAP')}`, value: 'DAP'},
        { text: `${this.$t('DDP')}`, value: 'DDP'},
        { text: `${this.$t('EXW')}`, value: 'EXW'},
        { text: `${this.$t('CPT')}`, value: 'CPT'},
      ],
      dutyPaidByOptions: [
        { text: `${this.$t('Seller')}`, value: 1},
        { text: `${this.$t('Reciever')}`, value: 2},
        { text: `${this.$t('Third party')}`, value: 3},
      ],
      additionalInfoOptions: [
        {
          text: 'ECCN',
          value: '2',
        },
        {
          text: 'EEI',
          value: '3',
        },
        {
          text: 'TEXT',
          value: '22',
        },
      ],
      tinTypeOptions: [
        { text: `${i18n.t('BUSINESS_NATIONAL')}`, value: 1},
        { text: `${i18n.t('BUSINESS_STATE')}`, value: 2},
        { text: `${i18n.t('BUSINESS_UNION')}`, value: 3},
        { text: `${i18n.t('PERSONAL_NATIONAL')}`, value: 4},
        { text: `${i18n.t('PERSONAL_STATE')}`, value: 5},
      ],
      invoiceTypeOptions: [
        { text: `${i18n.t('Sample')}`, value: 1},
        { text: `${i18n.t('Sale')}`, value: 2},
        { text: `${i18n.t('Gift')}`, value: 3},
        { text: `${i18n.t('Return_1')}`, value: 4},
        { text: `${i18n.t('Repair')}`, value: 5},
        { text: `${i18n.t('Temporary export')}`, value: 6},
        { text: `${i18n.t('Exhibition goods')}`, value: 7},
        { text: `${i18n.t('Testing analysis')}`, value: 8},
      ],
      // Table
      type: {
        type: false,
        data: 'type',
        text: `${this.$t('type')}`,
        icons: {
          1: 'single',
          2: 'building',
        },
      },
      referenceData: [
        {
          name: `${this.$t('name')}`,
        },
        {
          phone: this.$t('phone'),
          email: 'Email',
        },
      ],
    };
  },
  created() {
    this.$store.dispatch('GET_PAYERS_OPTIONS');

    this.$store.dispatch('GET_CUSTOMER', this.$route.params.id).then(() => {
      this.formInfo = {
        name: this.get_customer.name,
        company_name: this.get_customer.company_name,
        email: this.get_customer.email,
        vat: this.get_customer.vat,
        type: this.get_customer.type,
        phone: {
          number: this.get_customer.phone,
          country: '',
        },
        external_customer_no: this.get_customer.external_customer_no
      };
      this.formAddress = {
        address_1: this.get_customer.address_1,
        address_2: this.get_customer.address_2,
        post_code: this.get_customer.post_code,
        city: this.get_customer.city,
        state: this.get_customer.state,
        country_id: this.get_customer.country_id,
      };

      // Load additional shipping info if available
      if (this.get_customer.goods_incoterm) {
        this.additionalShippingInfo = {
          goods_incoterm: this.get_customer.goods_incoterm || '',
          duty_paid_by: this.get_customer.duty_paid_by || '',
          duty_payer_account_no: this.get_customer.duty_payer_account_no || '',
          freight_paid_by: this.get_customer.freight_paid_by || '',
          freight_payer_account_no: this.get_customer.freight_payer_account_no || '',
          freight_payer_id: this.get_customer.freight_payer_id || '',
          invoice_type: this.get_customer.invoice_type,
          eori: this.get_customer.eori || '',
          eccn: this.get_customer.eccn || '',
          customs_additional_info_text: this.get_customer.customs_additional_info_text || '',
          eei_number: this.get_customer.eei_number || '',
          tin_number: this.get_customer.tin_number || '',
          tin_type: this.get_customer.tin_type || '',
        };

        // Parse selected info items if they exist
        if (this.get_customer.selected_info_items) {
          this.selectedInfoItems = typeof this.get_customer.selected_info_items === 'string'
            ? JSON.parse(this.get_customer.selected_info_items)
            : this.get_customer.selected_info_items;
        }
      }
    });
  },
  computed: {
    ...mapGetters(['get_customer','get_active_subaccount', 'get_payers', 'get_payer_select']),
    isPopupSubmitDisabled() {
      if(this.formInfo.phone &&  this.formInfo.phone.number && this.formInfo.phone.number.length < 6) return true;
      let formWithValidators = [
        {
          formFeild:'country_id',
          value: this.formAddress.country_id,
          validators:{required: true}
        },
        {
          formFeild:'post_code',
          value: this.formAddress.post_code,
          validators:{required: true}
        },
        {
          formFeild:'city',
          value: this.formAddress.city,
          validators:{required: true}
        },
        {
          formFeild:'address_1',
          value: this.formAddress.address_1,
          validators:{required: true}
        },
        {
          formFeild:'name',
          value: this.formInfo.name,
          validators:{required: this.formInfo.type == 2}
        }
      ]

      if(this.formInfo.type == 1){
        formWithValidators.push({
          formFeild:'company_name',
          value: this.formInfo.company_name,
          validators:{required: true}
        })
      } else {
        formWithValidators.filter((item) => item.formFeild != 'company_name')
      }

      return this.validateInput(formWithValidators);
    },
    isPopupAddressSubmitDisabled() {
      const formWithValidators = [
        {
          formFeild:'name',
          value: this.addressFormInfo.name,
          validators:{required: true}
        },
      ]

      return this.validateInput(formWithValidators);
    },
    addressesForRender() {
      if(!this.get_customer.hasOwnProperty('addresses')) return [];
      return this.get_customer.addresses.map((address) => {
        return address;
      });
    },
    freightPaidByOptions() {
      const options = [];
      options.push({ text: `${this.$t('Seller')}`, value: 1})
      if (this.get_payers.items.length > 0) {
        options.push({ text: `${this.$t('LBL_PAYER_LIST')}`, value: 4})
      }
      options.push({ text: `${this.$t('Other')}`, value: 2})

      return options
    },
  },
  methods: {
    routeIt() {
      this.$router.go(-1);
    },

    // Additional shipping info methods
    checkDutyAndCarrierNo(val) {
      if(val === 'DDP') {
        this.additionalShippingInfo.duty_paid_by = 1;
      } else {
        this.additionalShippingInfo.duty_paid_by = '';
        this.additionalShippingInfo.duty_payer_account_no = '';
      }
    },
    checkCarrierNo(val) {
      if(parseInt(val) !== 3 && parseInt(val) !== 2) {
        this.additionalShippingInfo.duty_payer_account_no = '';
      }
    },
    checkFreightandCustomerInfo(val) {
      if(parseInt(val) !== 2 && parseInt(val) !== 3) {
        this.additionalShippingInfo.freight_payer_account_no = '';
      }
      if(parseInt(val) !== 4) {
        this.additionalShippingInfo.freight_payer_id = '';
      }
    },
    selectAdditionalInfo(val) {
      this.selectedInfoItems = val;

      // Clear fields if they're not selected
      if(this.selectedInfoItems.indexOf('2') < 0){
        this.additionalShippingInfo.eccn = '';
      }
      if(this.selectedInfoItems.indexOf('22') < 0){
        this.additionalShippingInfo.customs_additional_info_text = '';
      }
      if(this.selectedInfoItems.indexOf('3') < 0){
        this.additionalShippingInfo.eei_number = '';
        this.additionalShippingInfo.tin_number = '';
        this.additionalShippingInfo.tin_type = '';
      }
    },

    // Edit address popup
    openAddressFormPopup(item) {
      this.addressFormPopup = true;
      this.addressFormAddress = {
        address_1: this.get_customer.address_1,
        address_2: this.get_customer.address_2,
        post_code: this.get_customer.post_code,
        city: this.get_customer.city,
        state: this.get_customer.state,
        country_id: this.get_customer.country_id,
      };
      if(typeof item == 'undefined'){
        // ADD FORM POPUP
        this.isAddressEdit = false;
        this.addressFormInfo = {
          name: '',
          email: '',
          vat: '',
          phone: {
            number: '',
            country: this.getCountry(this.get_customer.country_id, 'alpha2'),
          },
        }
      } else {
        // EDIT FORM POPUP
        this.isAddressEdit = true;
        this.addressId = item.id;
        this.addressFormInfo = {
          name: item.name,
          email: item.email,
          vat: item.vat,
          phone: {
            number: item.phone,
            country: this.getCountry(item.country_id, 'alpha2'),
          },
        };
      }
    },
    closeAddressFormPopup() {
      this.addressFormPopup = false;
      this.isAddressEdit = false;
      this.deleteAddress = false;
      this.addressId = '';
      this.addressFormAddress = {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        state: '',
        country_id: '',
      };
      this.addressFormInfo = {
        name: '',
        email: '',
        vat: '',
        phone: {
          number: '',
          country: '',
        },
      };
    },
    changeAddressForm(val) {
      this.addressFormAddress.address_1 = val.address_1 || '';
      this.addressFormAddress.address_2 = val.address_2 || '';
      this.addressFormAddress.country_id = val.country_id || '';
      this.addressFormAddress.post_code = val.post_code || '';
      this.addressFormAddress.city = val.city || '';

      let flag = false;
      stateList.forEach((state) => {
        if(state.country_name ==  this.getCountry(val.country_id, 'name')){
          flag = true;
        }
      });

      if(flag){
        this.addressFormAddress.state = val.state;
      } else {
        this.addressFormAddress.state = '';
      }
    },
    submitAddressForm() {
      if(!this.isAddressEdit) {
        // SUBMIT ADD ADRESS
        this.$store.dispatch('ADD_CUSTOMER_ADDRESS', {
          form: {...this.addressFormAddress, ...this.addressFormInfo, phone: this.addressFormInfo.phone.number, company_name: this.get_customer.company_name},
          id: this.$route.params.id,
        }).then(() => {
          this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
          this.closeAddressFormPopup();
        });
      } else {
        // SUBMIT EDIT ADRESS
        this.$store.dispatch('EDIT_CUSTOMER_ADDRESS', {
          form: {...this.addressFormAddress, ...this.addressFormInfo, phone: this.addressFormInfo.phone.number, company_name: this.get_customer.company_name},
          id: this.$route.params.id,
          addressId: this.addressId,
        }).then(() => {
          this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
          this.closeAddressFormPopup();
        });
      }
    },
    deleteAddressAction() {
      this.$store.dispatch('DELETE_CUSTOMER_ADDRESS', {
        customerId: this.$route.params.id,
        addressId: this.addressId,
      }).then(() => {
        this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
        this.closeAddressFormPopup();
      })
    },

    // Customer popup
    openEditPopup() {
      this.edit = true;
    },
    closeEditPopup() {
      this.edit = false;
    },
    changeAddress(val) {
      this.formAddress.address_1 = val.address_1 || '';
      this.formAddress.address_2 = val.address_2 || '';
      this.formAddress.country_id = val.country_id || '';
      this.formAddress.post_code = val.post_code || '';
      this.formAddress.city = val.city || '';

      let flag = false;
      stateList.forEach((state) => {
        if(state.country_name ==  this.getCountry(val.country_id, 'name')){
          flag = true;
        }
      });

      if(flag){
        this.formAddress.state = val.state;
      } else {
        this.formAddress.state = '';
      }
    },
    submitEditForm() {
      // Prepare the form data including additional shipping info
      const formData = {
        ...this.formAddress,
        ...this.formInfo,
        phone: this.formInfo.phone.number,
        // Additional shipping information
        ...this.additionalShippingInfo,
        selected_info_items: JSON.stringify(this.selectedInfoItems),
        additional_info_updated_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
      };

      this.$store.dispatch('EDIT_CUSTOMER', {
        form: formData,
        id: this.$route.params.id,
      }).then(() => {
        this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
        this.edit = false;
      });
    },
    deleteCustomerAction() {
      this.$store.dispatch('DELETE_CUSTOMERS', {
        type: 'byId',
        id: 0,
        ids: [this.$route.params.id],
      }).then(() => {
        this.$router.push('/contacts')
      });
    },
  },
  beforeDestroy() {
    this.$store.dispatch('CLEAR_CUSTOMER_FROM_STORE');
  },
};
</script>
